@if (appBusyState) {
<div class="app-busy">
    @if (!!$any(appBusyState).templatePortal) {
    <ng-container [cdkPortalOutlet]="$any(appBusyState).templatePortal" />
    } @else {
    <p class="center">{{$any(appBusyState).message}}</p>
    }
</div>
}